import React from "react";
import CountryDropDown from "../utils/countryDropDown/CountryDropDown";
import { ReactComponent as AddIcon } from "../../../../../assets/svg/queryplus-icon.svg";
import { ReactComponent as CancelIcon } from "../../../../../assets/svg/close.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as TranslateHeaderIcon } from "../../../../../assets/svg/translate-header.svg";
import Select from "react-select";
import { ReactComponent as FieldAddIcon } from "../../../../../assets/svg/add.svg";
import { Scrollbars } from "react-custom-scrollbars";
import { ReactComponent as ExpandIcon } from "../../../../../assets/svg/chevron.svg";
import QueryResults from "../queryResults/QueryResults";
import { ReactComponent as InfoIcon } from "../../../../../assets/svg/info-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { setKeywordTypeValue } from "../../../../../actions/queryBuilderActions";
import "./ConfigureKeywords.scss";
import { LimitMessage } from "../../../../SubscriptionModule/LimitComponents";

const ConfigureKeywords = (props) => {
    const {
        addExcludedField,
        expandKeywordBlock,
        selectedCountryOptions,
        handleCountryChange,
        keywords,
        addKeywordsField,
        handleKeyWordChange,
        clearKeyword,
        enableTranslateBlock,
        langOptionsCalculations,
        handleLanguageChange,
        increaseTranslate,
        addTranslatedText,
        removeTranslate,
        keywordDivEnd,
        genericKeyword,
        addGenericField,
        handleGenericChange,
        toggleShowSampleData,
        phrasesDivEnd,
        excludeDivEnd,
        showSampleButtonState,
        showSamplePosts,
        rawData,
        queryResultsLoading,
        queryResults,
        finalQuery,
        characterLeftForBoolean,
        excludedKeyword,
        isSampleDataBlockOpened,
        fetchNewData,
        handleKeyPress,
        handleExcludedKeyWord,
        disableLocationTab,
        isSetupMode,
        hideTabs,
    } = props;

    const dispatch = useDispatch();
    const keywordsFromStore = useSelector((state) => state.queryBuilderReducer.keywords);
    const genericKeywordFromStore = useSelector((state) => state.queryBuilderReducer.genericKeyword);
    const excludedKeywordFromStore = useSelector((state) => state.queryBuilderReducer.excludedKeyword);
    const supportedLanguages = useSelector((state) => state.queryBuilderReducer.allSupportedLanguages);
    const packageObj = useSelector((state) => state.globalReducer.packageObj);
    const dispatchKeywordType = (val, type) => dispatch(setKeywordTypeValue(val, type));

    const customStyle = {
        control: (base) => ({ ...base, border: 0, height: "30px", minHeight: "30px", top: "20%", boxShadow: "none", background: "#F7F7F7", color: "#1F2E3D" }),
        option: (styles, { isSelected }) => {
            return { ...styles, backgroundColor: isSelected ? "#F7F7F7" : null, color: "#1F2E3D" };
        },
        singleValue: (provided) => {
            return { ...provided, color: "#1F2E3D" };
        },
        dropdownIndicator: (base) => ({
            ...base,
            color: "#697384",
            padding: "4px",
        }),
        clearIndicator: (base) => ({
            ...base,
            color: "#697384",
            padding: "4px",
        }),
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#8093b2",
            };
        },
    };

    const handleAddIcon = (cb, gloablStoreValue, dispatchFn) => {
        if (gloablStoreValue.length < 5) cb(gloablStoreValue, dispatchFn);
        // addKeywordsField(keywordsFromStore, dispatchKeywordType)
    };

    return (
        <>
            <div className={`keyword__configurations profile__setup__mode `}>
                {expandKeywordBlock && (
                    <div className="configured__keyword-blocks add__margin">
                        <div className="keys__list">
                            {expandKeywordBlock && !disableLocationTab && (
                                <div className="location__field">
                                    <label>Select the Locations that you want to track</label>
                                    {!disableLocationTab && packageObj.package_code == "free" && (
                                        <LimitMessage
                                            packageObj={packageObj}
                                            message={"You cannot change the location, Please upgrade to get more Personalised data."}
                                            limitReached={packageObj.package_code === "free"}
                                            // totalCount={this.props.packageObj.features.number_of_queries.quota}
                                            // usedCount={queries}
                                        />
                                    )}
                                    <CountryDropDown
                                        selectedCountryOptions={selectedCountryOptions}
                                        isDisabled={true}
                                        handleCountryChange={handleCountryChange}
                                    />
                                </div>
                            )}
                            {isSetupMode ? (
                                <>
                                    <p className="header__text-keyword">
                                        Add keywords and hashtags that you would like to track. We will fetch data for your keywords from over 100 social
                                        networks and over a million blogs and forums.
                                    </p>
                                    {/* <p className="header__text-keyword">
                                        After adding keywords, please click on Show sample button to view sample data and proceed further
                                    </p> */}
                                    <p className="header__text-keyword">Contains</p>
                                </>
                            ) : (
                                <p className="header__text-keyword">Contains</p>
                            )}
                            <div className={`keyword__block ${disableLocationTab && "setup__mode"} ${hideTabs ? "row__contents" : ""}`}>
                                {/* <Scrollbars autoHide> */}
                                {keywords.map((ele, ind) => {
                                    return (
                                        <div key={ind} className={`keyword__field-row   `}>
                                            {!hideTabs ? (
                                                <span className="add__icon">
                                                    <AddIcon
                                                        onClick={
                                                            () => handleAddIcon(addKeywordsField, keywordsFromStore, dispatchKeywordType)
                                                            // addKeywordsField(keywordsFromStore, dispatchKeywordType)
                                                        }
                                                    />
                                                </span>
                                            ) : null}
                                            <div className="keyword__add-field">
                                                <input
                                                    type="text"
                                                    value={keywords[ind]["keyword"]}
                                                    className="input__field"
                                                    placeholder="Enter Keyword Ex:Apple"
                                                    onChange={(ev) => handleKeyWordChange(ev, ind)}
                                                    onKeyPress={(ev) => handleKeyPress(ev, "keywords")}
                                                    id={keywords[ind]["id"]}
                                                    autoComplete="off"
                                                />
                                                {keywords[ind]["keyword"].length >= 0 ? (
                                                    <CancelIcon onClick={() => clearKeyword(ind, "keywords")} />
                                                ) : (
                                                    <span></span>
                                                )}
                                            </div>
                                            {hideTabs ? (
                                                <span className="add__icon right__aligned">
                                                    <AddIcon
                                                        onClick={
                                                            () => handleAddIcon(addKeywordsField, keywordsFromStore, dispatchKeywordType)
                                                            // addKeywordsField(keywordsFromStore, dispatchKeywordType)
                                                        }
                                                    />
                                                </span>
                                            ) : null}
                                            {packageObj.package_code === "enterprise" ? (
                                                <span className="enable_translate-btn qb_step8">
                                                    {" "}
                                                    <Popup
                                                        inverted
                                                        className="skiptranslate"
                                                        size="tiny"
                                                        content="Translate"
                                                        trigger={
                                                            <TranslateHeaderIcon
                                                                className={`${keywords[ind]["keyword"].length > 0 ? "" : "disabled__view"}`}
                                                                onClick={() => {
                                                                    enableTranslateBlock(ind, "keywords");
                                                                }}
                                                            />
                                                        }
                                                    />{" "}
                                                </span>
                                            ) : null}
                                            {keywords[ind]["enable"] && keywords[ind]["keyword"].length > 0 && (
                                                <div className="translate__block-wrap">
                                                    {keywords[ind].translateOptionsList.map((elem, point) => {
                                                        return (
                                                            <div className={`translate__block ${isSampleDataBlockOpened ? "vertical__align" : ""}`} key={point}>
                                                                <Popup
                                                                    inverted
                                                                    size="tiny"
                                                                    content={
                                                                        keywords[ind]["translateOptionsList"][point]["selectedLanguage"]?.label ||
                                                                        "Select Language"
                                                                    }
                                                                    trigger={
                                                                        <div>
                                                                            <Select
                                                                                className="googleLanguage__list"
                                                                                value={keywords[ind]["translateOptionsList"][point]["selectedLanguage"]}
                                                                                isSearchable
                                                                                placeholder="Translate To"
                                                                                options={langOptionsCalculations(supportedLanguages)}
                                                                                onChange={(ev) => handleLanguageChange(ev, ind, "keywords", point)}
                                                                                maxMenuHeight={120}
                                                                                menuPosition="fixed"
                                                                                isClearable
                                                                                styles={customStyle}
                                                                                components={{ IndicatorSeparator: () => null }}
                                                                            />
                                                                        </div>
                                                                    }
                                                                />
                                                                <button className="add__btn" onClick={() => increaseTranslate(ind, "keywords", elem)}>
                                                                    <FieldAddIcon />
                                                                </button>
                                                                <input
                                                                    className="input__field"
                                                                    placeholder="Text"
                                                                    value={keywords[ind]["translateOptionsList"][point]["translatedText"]}
                                                                    disabled
                                                                />
                                                                <div className="add__refresh-block">
                                                                    <button
                                                                        className="add__btn"
                                                                        title="Add to Query"
                                                                        onClick={() => addTranslatedText(ind, "keywords", point)}>
                                                                        Add
                                                                    </button>

                                                                    {keywords[ind]["translateOptionsList"][point]["translatedText"] !== "" && (
                                                                        <span className="cancel__btn">
                                                                            <CancelIcon
                                                                                title="Remove"
                                                                                onClick={() => {
                                                                                    removeTranslate(ind, "keywords", point);
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                    <div ref={keywordDivEnd} />
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                                {/* </Scrollbars> */}
                            </div>
                            {!hideTabs ? (
                                <>
                                    <p className="center-align exclude__type">(And)</p>
                                    <p className="header__text-keyword">Also contains</p>
                                    <div className={`phrases__block ${disableLocationTab && "setup__mode"}`}>
                                        {genericKeyword.map((ele, ind) => {
                                            return (
                                                <div className="keyword__field-row" key={ind}>
                                                    <span className="add__icon">
                                                        <AddIcon onClick={() => handleAddIcon(addGenericField, genericKeywordFromStore, dispatchKeywordType)} />
                                                    </span>
                                                    <div className="keyword__add-field">
                                                        <input
                                                            type="text"
                                                            value={genericKeyword[ind]["keyword"]}
                                                            className="input__field"
                                                            placeholder="Enter Keyword Ex:#iPhone"
                                                            onChange={(ev) => handleGenericChange(ev, ind)}
                                                            onKeyPress={(ev) => handleKeyPress(ev, "genericKeyword")}
                                                            id={genericKeyword[ind]["id"]}
                                                            autoComplete="off"
                                                        />
                                                        {genericKeyword[ind]["keyword"].length >= 0 ? (
                                                            <CancelIcon onClick={() => clearKeyword(ind, "genericKeyword")} />
                                                        ) : (
                                                            <span></span>
                                                        )}
                                                    </div>
                                                    {packageObj.package_code === "enterprise" ? (
                                                        <span className="enable_translate-btn">
                                                            {" "}
                                                            <Popup
                                                                inverted
                                                                size="tiny"
                                                                content="Translate"
                                                                trigger={
                                                                    <TranslateHeaderIcon
                                                                        className={`${genericKeyword[ind]["keyword"].length > 0 ? "" : "disabled__view"}`}
                                                                        onClick={() => {
                                                                            enableTranslateBlock(ind, "genericKeyword");
                                                                        }}
                                                                    />
                                                                }
                                                            />{" "}
                                                        </span>
                                                    ) : null}

                                                    {genericKeyword[ind]["enable"] && (
                                                        <div className="translate__block-wrap">
                                                            {genericKeyword[ind].translateOptionsList.map((elem, point) => {
                                                                return (
                                                                    <div
                                                                        className={`translate__block ${isSampleDataBlockOpened ? "vertical__align" : ""}`}
                                                                        key={point}>
                                                                        <Popup
                                                                            inverted
                                                                            size="tiny"
                                                                            content={
                                                                                genericKeyword[ind]["translateOptionsList"][point]["selectedLanguage"]?.label ||
                                                                                "Select Language"
                                                                            }
                                                                            trigger={
                                                                                <div>
                                                                                    <Select
                                                                                        className="googleLanguage__list"
                                                                                        value={
                                                                                            genericKeyword[ind]["translateOptionsList"][point][
                                                                                                "selectedLanguage"
                                                                                            ]
                                                                                        }
                                                                                        isSearchable
                                                                                        placeholder="Translate To"
                                                                                        options={langOptionsCalculations(supportedLanguages)}
                                                                                        onChange={(ev) =>
                                                                                            handleLanguageChange(ev, ind, "genericKeyword", point)
                                                                                        }
                                                                                        maxMenuHeight={120}
                                                                                        menuPosition="fixed"
                                                                                        isClearable
                                                                                        styles={customStyle}
                                                                                        components={{ IndicatorSeparator: () => null }}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        />

                                                                        <button
                                                                            className="add__btn"
                                                                            onClick={() => increaseTranslate(ind, "genericKeyword", elem)}>
                                                                            <FieldAddIcon />
                                                                        </button>
                                                                        <input
                                                                            className="input__field"
                                                                            placeholder="Text"
                                                                            value={genericKeyword[ind]["translateOptionsList"][point]["translatedText"]}
                                                                            disabled
                                                                        />
                                                                        <div className="add__refresh-block">
                                                                            <button
                                                                                className="add__btn"
                                                                                title="Add to Query"
                                                                                onClick={() => addTranslatedText(ind, "genericKeyword", point)}>
                                                                                Add
                                                                            </button>
                                                                            {genericKeyword[ind]["translateOptionsList"][point]["translatedText"] !== "" && (
                                                                                <span className="cancel__btn">
                                                                                    <CancelIcon
                                                                                        title="Remove"
                                                                                        onClick={() => {
                                                                                            removeTranslate(ind, "genericKeyword", point);
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                            <div ref={phrasesDivEnd} />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <p className="center-align exclude__type">{`(${isSetupMode ? "Not" : "And Not"})`}</p>
                                    <p className="header__text-keyword">Does not contain</p>
                                    <div className={`exclude__keyword-block ${disableLocationTab && "setup__mode"}`}>
                                        {excludedKeyword.map((ele, ind) => {
                                            return (
                                                <div className="keyword__field-row" key={ind}>
                                                    <span className="add__icon">
                                                        <AddIcon
                                                            onClick={() => handleAddIcon(addExcludedField, excludedKeywordFromStore, dispatchKeywordType)}
                                                        />
                                                    </span>
                                                    <div className="keyword__add-field">
                                                        <input
                                                            type="text"
                                                            value={excludedKeyword[ind]["keyword"]}
                                                            className="input__field"
                                                            placeholder="Enter Keyword. Ex:fruit"
                                                            onChange={(ev) => handleExcludedKeyWord(ev, ind)}
                                                            onKeyPress={(ev) => handleKeyPress(ev, "excludedKeyword")}
                                                            id={excludedKeyword[ind]["id"]}
                                                            autoComplete="off"
                                                        />
                                                        {excludedKeyword[ind]["keyword"].length >= 0 ? (
                                                            <CancelIcon onClick={() => clearKeyword(ind, "excludedKeyword")} />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                    {packageObj.package_code === "enterprise" ? (
                                                        <span className="enable_translate-btn">
                                                            {" "}
                                                            <Popup
                                                                inverted
                                                                className="skiptranslate"
                                                                size="tiny"
                                                                content="Translate"
                                                                trigger={
                                                                    <TranslateHeaderIcon
                                                                        className={`${excludedKeyword[ind]["keyword"].length > 0 ? "" : "disabled__view"}`}
                                                                        onClick={() => {
                                                                            enableTranslateBlock(ind, "excludedKeyword");
                                                                        }}
                                                                    />
                                                                }
                                                            />{" "}
                                                        </span>
                                                    ) : null}
                                                    {excludedKeyword[ind]["enable"] && (
                                                        <div className="translate__block-wrap">
                                                            {excludedKeyword[ind].translateOptionsList.map((elem, point) => {
                                                                return (
                                                                    <div
                                                                        className={`translate__block ${isSampleDataBlockOpened ? "vertical__align" : ""}`}
                                                                        key={point}>
                                                                        <Popup
                                                                            inverted
                                                                            size="tiny"
                                                                            content={
                                                                                excludedKeyword[ind]["translateOptionsList"][point]["selectedLanguage"]
                                                                                    ?.label || "Select Language"
                                                                            }
                                                                            trigger={
                                                                                <div>
                                                                                    <Select
                                                                                        className="googleLanguage__list"
                                                                                        value={
                                                                                            excludedKeyword[ind]["translateOptionsList"][point][
                                                                                                "selectedLanguage"
                                                                                            ]
                                                                                        }
                                                                                        isSearchable
                                                                                        placeholder="Translate To"
                                                                                        options={langOptionsCalculations(supportedLanguages)}
                                                                                        onChange={(ev) =>
                                                                                            handleLanguageChange(ev, ind, "excludedKeyword", point)
                                                                                        }
                                                                                        maxMenuHeight={120}
                                                                                        menuPosition="fixed"
                                                                                        isClearable
                                                                                        styles={customStyle}
                                                                                        components={{ IndicatorSeparator: () => null }}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        />
                                                                        <button
                                                                            className="add__btn"
                                                                            onClick={() => increaseTranslate(ind, "excludedKeyword", elem)}>
                                                                            <FieldAddIcon />
                                                                        </button>
                                                                        <input
                                                                            className="input__field"
                                                                            placeholder="Text"
                                                                            value={excludedKeyword[ind]["translateOptionsList"][point]["translatedText"]}
                                                                            disabled
                                                                        />
                                                                        <div className="add__refresh-block">
                                                                            <button
                                                                                className="add__btn"
                                                                                title="Add to Query"
                                                                                onClick={() => addTranslatedText(ind, "excludedKeyword", point)}>
                                                                                Add
                                                                            </button>
                                                                            {excludedKeyword[ind]["translateOptionsList"][point]["translatedText"] !== "" && (
                                                                                <span className="cancel__btn">
                                                                                    <CancelIcon
                                                                                        title="Remove"
                                                                                        onClick={() => {
                                                                                            removeTranslate(ind, "excludedKeyword", point);
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                            <div ref={excludeDivEnd} />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            ) : null}
                        </div>
                        {!isSampleDataBlockOpened && (
                            <>
                                {!hideTabs ? (
                                    <div className="editable__keyword-block">
                                        <div className="header__align">
                                            {isSetupMode ? (
                                                <p className="query__header">Your Query</p>
                                            ) : (
                                                <p className="query__header">Your Query - Keywords and Hashtags</p>
                                            )}
                                            <div className="header">
                                                <p className="character__msg">{characterLeftForBoolean()} Characters left</p>

                                                <Popup
                                                    style={{ backgroundColor: "#1f2e3d", color: "white" }}
                                                    inverted
                                                    content={
                                                        fetchNewData
                                                            ? "Number of Characters available for a query is 2048 characters. This includes the Query itself as well as the locations you select."
                                                            : `Number of Characters available for the query is ${
                                                                  packageObj.package_code === "free" ? "1024" : "5000"
                                                              }  characters`
                                                    }
                                                    trigger={<InfoIcon className="info__icon" />}
                                                />
                                            </div>
                                        </div>
                                        <textarea
                                            value={finalQuery}
                                            disabled={true}
                                            className="query__block text__area__easy__query__builder"
                                            // placeholder="(Apple)
                                            //                     AND (iPhone)
                                            //                     AND NOT (fruit)"

                                            placeholder={`(${
                                                isSetupMode ? "(Apple) AND (iPhone) NOT (fruit)" : "(Apple) AND (iPhone) AND NOT (fruit)"
                                            })`}></textarea>

                                        {packageObj.package_code === "enterprise" ? (
                                            <button
                                                className="show__sample-btn qb_step9"
                                                disabled={showSampleButtonState}
                                                onClick={() => {
                                                    showSamplePosts();
                                                }}>
                                                Show Sample Data
                                            </button>
                                        ) : null}
                                    </div>
                                ) : null}
                            </>
                        )}
                        {isSampleDataBlockOpened && (
                            <div className="collapsed__query-block">
                                <div className={`sample__post_header ${isSampleDataBlockOpened ? "" : "align__vertical"}`}>
                                    <span
                                        onClick={() => {
                                            toggleShowSampleData();
                                        }}>
                                        <ExpandIcon className={`${isSampleDataBlockOpened ? "collapse-icon" : ""}`} />
                                    </span>
                                    <div className={`center-align ${isSampleDataBlockOpened ? "rotate-text" : ""}`}>
                                        <p className="sample__label">Your Query</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {packageObj.package_code === "enterprise" ? (
                            <div className={`show__sampleData-wrapper ${isSampleDataBlockOpened ? "expand__left" : "shrink__right"}`}>
                                <div className={`sample__post_header ${isSampleDataBlockOpened ? "" : "align__vertical"}`}>
                                    <span
                                        onClick={() => {
                                            toggleShowSampleData();
                                        }}>
                                        <ExpandIcon className={`${isSampleDataBlockOpened ? "" : "collapse-icon"}`} />
                                    </span>

                                    <div className={`center-align ${isSampleDataBlockOpened ? "" : "rotate-text"}`}>
                                        <p className="sample__label">
                                            Sample Data
                                            {isSampleDataBlockOpened ? " (Last 7 Days)" : ""}
                                        </p>
                                    </div>
                                </div>
                                <div className={`easyMode__right-block ${isSampleDataBlockOpened ? "" : "shrink__right-bgc"}`}>
                                    <Scrollbars autoHide>
                                        {rawData == 0 && queryResults.total === 0 && isSampleDataBlockOpened && <div className="no-posts">No Data</div>}
                                        {/* {this.props.platformWiseData.length > 0 && this.props.queryResults.total > 0 && (
                                            <PlatformWiseAnalysis platformWiseData={this.props.platformWiseData} />
                                             )} */}
                                        {isSampleDataBlockOpened && <QueryResults rawData={rawData} queryResultsLoading={queryResultsLoading} />}
                                    </Scrollbars>
                                </div>
                                {isSampleDataBlockOpened && (
                                    <button
                                        className="show__sample-btn"
                                        disabled={showSampleButtonState}
                                        onClick={() => {
                                            showSamplePosts();
                                        }}>
                                        Show Sample Data
                                    </button>
                                )}
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </>
    );
};

export default ConfigureKeywords;
